import { useMutation } from '@tanstack/react-query'
import { BiometryService } from '../services'

type BiometryStartMutation = {
  withoutLogin: boolean
  cpf: string
  captcha: string
  callbackUri: string
}

export const useBiometryStart = () => {
  const mutation = useMutation({
    mutationFn: async (params: BiometryStartMutation) => {
      if (params?.withoutLogin) {
        const response = await BiometryService.biometryStartPatient(
          params?.callbackUri,
          params?.cpf,
          params?.captcha,
        )
        return response
      }

      const response = await BiometryService.biometryStart(params?.callbackUri)

      return response
    },
  })

  return mutation
}
